import { Component, ChangeDetectionStrategy, ViewChild, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LibrariesPageComponent } from '../../libraries-page-refactored.component';
import { LibraryExplorerStateService } from '../../services/library-explorer-state.service';
import { AppStateService } from '../../../../services/state-store/app-state';

// Temporary Wrapper component to provide an isolated instance of LibraryExplorerStateService
// and pass modal-specific configuration to LibrariesPageComponent for use in modals.
@Component({
  selector: 'app-template-explorer-modal-wrapper',
  standalone: true,
  imports: [CommonModule, LibrariesPageComponent],
  providers: [LibraryExplorerStateService],
  templateUrl: './template-explorer-modal-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateExplorerModalWrapperComponent {
  @Input() modalCategory: number | null = null;
  @ViewChild('libPage', { static: false }) libPage?: LibrariesPageComponent;
  get data() {
    // LibrariesPage's data getter already filters for templates when isInModal=true
    return this.libPage?.data;
  }
}